import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
 


import './core/lazy_use' // use lazy load components
import './permission' // permission control
// 引入全局css
import './assets/less/base.less';

// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);

//引入动画库 
import 'vue2-animate/dist/vue2-animate.css';

//轻量级手势库，支持点击、长按、滑动等手势。
//import Vue2TouchEvents from 'vue2-touch-events';
//Vue.use(Vue2TouchEvents);
//v-touch:swipe.right="handleRightSwipe"
//功能强大的手势库，支持多种手势和复杂的手势识别。
import { VueHammer } from 'vue2-hammer';//
// VueHammer.config.press = { 
// 	time: 800,// 设置为800ms触发长按
// 	//requireFailure: 'tap', // 直接声明依赖关系 
// }; 
Vue.use(VueHammer);
//v-hammer:swipe.right="handleRightSwipe" 

// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})


import highcharts from 'highcharts'
import highcharts3d from 'highcharts/highcharts-3d'
highcharts3d(highcharts)
//引入echart
//4.x 引用方式
import echarts from 'echarts'
//5.x 引用方式为按需引用
//希望使用5.x版本的话,需要在package.json中更新版本号,并切换引用方式
//import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import 'core-js/stable';
import 'regenerator-runtime/runtime';
//import utils from '@/utils'
//Vue.prototype.$utils = utils

import tagCloud from 'v-tag-cloud'
Vue.use(tagCloud)
Vue.config.productionTip = false;
Vue.prototype.$fontSize = window.document.documentElement.style.fontSize.replace('px', '')


import { longClickDirective } from 'vue-long-click'
const longClickInstance = longClickDirective({delay: 400, interval: 50})
Vue.directive('longclick', longClickInstance)

// 全局注册
Vue.component('icon', Icon);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
